import * as React from "react";
import { Tooltip } from "@mui/material";
import { useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import Box from "@mui/material/Box";
import { PRODUCT_PAGE } from "../../../utils/RouteUtils";
import { Link } from "react-router-dom";

interface State {
  width: number;
}

const LastSeenFArticleComponent = React.memo(
  React.forwardRef(({ width }: State, ref) => {
    const lastSeenFArticles = useAppSelector(
      (state: RootState) => state.globalState.lastSeenFArticles
    );
    const user = useAppSelector((state: RootState) => state.globalState.user);

    return (
      <>
        {width > 0 && (
          <Box
            sx={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              display: "flex",
              maxWidth: width + "px",
            }}
          >
            {lastSeenFArticles &&
              [...lastSeenFArticles]
                .filter(
                  (x) =>
                    x.userIdentifier === undefined ||
                    x.userIdentifier === user?.userIdentifier
                )
                .reverse()
                .map((lastSeenFArticle, indexLastSeenFArticle) => (
                  <Box key={indexLastSeenFArticle}>
                    <Tooltip title={lastSeenFArticle.name ?? ""}>
                      <Link
                        to={PRODUCT_PAGE + "/" + lastSeenFArticle.fArticleId}
                      >
                        <img
                          src={
                            (process.env.REACT_APP_API_URL ?? "") +
                            lastSeenFArticle.image
                          }
                          style={{
                            width: "46px",
                            height: "46px",
                            margin: "auto",
                            display: "block",
                          }}
                          alt={lastSeenFArticle.fArticleId}
                          loading="lazy"
                          referrerPolicy="no-referrer"
                        />
                      </Link>
                    </Tooltip>
                  </Box>
                ))}
          </Box>
        )}
      </>
    );
  })
);

export default LastSeenFArticleComponent;
